import { useEffect } from "react";

import { useDispatch } from "react-redux";

import { SeoTags } from "../../components";
import { PaymentInfo } from "../../components/info/PaymentComponent";
import { setShowSearch } from "../../store/appConfigsSlice";

const InfoPaymentPage = () => {
	const dispatch = useDispatch()

	useEffect (() => {
		dispatch(setShowSearch(false))
	}, []);

	return (
		<>
			<SeoTags pageKey="paymentInfoPage" />
			<PaymentInfo />
		</>
	);
};

export default InfoPaymentPage;